import { FileActionButton } from "../file-action/file-action-controls";
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import editUserServices from '../../services/edit-users/edit-users.service';
import UsersSearch from './users-search';
import UsersDataTable from './users-datatable';
import { OtherUserModel } from '../../models/all-user/edit-user-model';
import AppLoading from '../app-loading/app-loading';
import { exportCustomersFromData } from './customers-export';

const EditUsers: React.FC = () => {
    
    const { t } = useTranslation();
    const [userList, setUserList] = useState<OtherUserModel[]>([]);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [loading, setLoading] = useState(false);
    const [allUsers,setAllUsers] = useState(false);

    useEffect(() => {              
        handleSearch("");
    }, [refreshTrigger]);

    function handleSearch(query: string): void {
        setLoading(true);
        editUserServices.getUsers(query).then((response: any) => {
            const sortedData = [...response].sort((a, b) => b.userID - a.userID);
            setUserList(sortedData);
            setLoading(false);
        });
    }

    const reloadPage = () => {
        setRefreshTrigger(prev => prev + 1);
    } 

    function handelnewUsersList(val:boolean){
        setAllUsers(val);
    }

    function handelNewDateFilter(filter : any){
        setLoading(true);
        editUserServices.getNewUsersList(filter).then((response: any) => {
            setUserList(response);
            setLoading(false);
        });      
    }

    const handleExport = async () => {
        if (!userList || userList.length === 0) {
            console.warn('No data to export.');
            return;
        }
        setLoading(true);
        try {
            await exportCustomersFromData(userList);
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <>
        <style>{`
            .complaint-header-card {
                background: linear-gradient(135deg, #f8fffe 0%, #e8f5e9 100%);
                border-radius: 16px;
                padding: 1.5rem 2rem;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
                border: 1px solid rgba(76, 175, 80, 0.1);
                margin-bottom: 1.5rem;
            }

            .complaint-title-wrapper {
                display: flex;
                align-items: center;
                gap: 0.75rem;
            }

            .complaint-icon-wrapper {
                width: 48px;
                height: 48px;
                background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
            }

            .complaint-icon-wrapper i {
                color: white;
                font-size: 1.5rem;
            }

            @media screen and (max-width: 768px) {
                .complaint-header-card .flex {
                    flex-direction: column;
                    align-items: flex-start !important;
                    gap: 1rem;
                }
            }
        `}</style>
        <div className="layout-content mt-3 mb-3" style={{ maxWidth: '100vw', overflowX: 'hidden' }}>
            <div className="complaint-header-card">
                <div className="flex align-items-center justify-content-between">
                    <div>
                        <div className="complaint-title-wrapper">
                            <div className="complaint-icon-wrapper">
                                <i className="pi pi-users"></i>
                            </div>
                            <div>
                                <h1 className="text-800 font-bold text-3xl m-0" style={{ color: "#10492a" }}>
                                    {!allUsers ? t('edit_users_head') : 'New Customers'}
                                </h1>
                                <p className="text-600 m-0 text-sm mt-1">
                                    Track, manage, and view customer details efficiently
                                </p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <FileActionButton action="export" menuId={12}
                            className="text-black border-round mr-2 mb-1"
                            onClick={handleExport}
                            icon="pi pi-file-export mr-1"
                            text
                            raised
                            tooltip={`Export ${userList?.length ?? 0} customer(s) to Excel`}
                            tooltipOptions={{ position: 'top' }}
                            style={{ width: 'auto' }}
                        >
                            Export Customers
                        </FileActionButton>
                    </div>
                </div>
            </div>

            <UsersSearch onSearch={handleSearch} reloadPage={reloadPage} setLoading={setLoading} newUsersList={handelnewUsersList} onDateFilter={handelNewDateFilter}/> 
            <div className="mt-4">
            {
              !allUsers ? <UsersDataTable data={userList}/> : 
               <UsersDataTable data={userList}/>
            }
            </div>
        </div>
        {loading && <AppLoading />}
        </>
    );
}

export default EditUsers;